import React, { useEffect } from 'react';
import { useAuth } from "../../contexts/AuthContext";
import DisplayContent from "./screen/DisplayContent";

const Screen = () => {
    const { logout } = useAuth();

    useEffect(() => {
        const enterFullscreen = async () => {
            try {
                if (document.documentElement.requestFullscreen) {
                    await document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) { // Firefox
                    await document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) { // Chrome, Safari and Opera
                    await document.documentElement.webkitRequestFullscreen();
                } else if (document.documentElement.msRequestFullscreen) { // IE/Edge
                    await document.documentElement.msRequestFullscreen();
                }
            } catch (error) {
                console.error("Error attempting to enable full-screen mode:", error);
            }
        };

        enterFullscreen();

        return () => {
            if (!document.fullscreenElement &&
                !document.webkitFullscreenElement &&
                !document.mozFullScreenElement &&
                !document.msFullscreenElement) {
                // If not in fullscreen, no need to exit
                return;
            }

            if (document.exitFullscreen) {
                document.exitFullscreen().catch(e => console.error("Error exiting fullscreen:", e));
            } else if (document.mozCancelFullScreen) { // Firefox
                document.mozCancelFullScreen().catch(e => console.error("Error exiting fullscreen:", e));
            } else if (document.webkitExitFullscreen) { // Chrome, Safari and Opera
                document.webkitExitFullscreen().catch(e => console.error("Error exiting fullscreen:", e));
            } else if (document.msExitFullscreen) { // IE/Edge
                document.msExitFullscreen().catch(e => console.error("Error exiting fullscreen:", e));
            }
        };
    }, []);

    const handleLogoutClick = () => {
        if (window.confirm("Do you really want to log out?")) {
            logout();
        }
    };

    return (
        <div style={{width: '100vw', height: '100vh'}} onClick={handleLogoutClick}>
            <DisplayContent />
        </div>
    );
};

export default Screen;
